import { type ReactNode, useCallback } from 'react';

import { GalleryLayout } from '../../containers/ResidentialCardContainer/components/GalleryLayout';
import { PublisherDesktopLayout } from '../../containers/ResidentialCardContainer/components/PublisherDesktopLayout';
import { CardContentLayout } from '../CardContentLayout';
import { CardLayout } from '../CardLayout';
import { CardList, CardListItem } from '../CardListLayout';
import { SkeletonRect } from '../SkeletonRect';

import styles from './SkeletonCardList.css';

type TSceletonCardList = {
  of: number;
  isNarrow?: boolean;
  isTop: boolean;
};

export function SkeletonCardList({ of, isTop, isNarrow }: TSceletonCardList): ReactNode {
  const renderThumbnail = useCallback(
    (index: number) => (
      <CardListItem key={`skeleton-item-${index}`}>
        <CardLayout
          content={
            <CardContentLayout
              actions={<SkeletonRect className={styles['actions']} />}
              description={
                <div className={styles['description']}>
                  <SkeletonRect />
                </div>
              }
              geo={
                <div className={styles['geo']}>
                  <SkeletonRect className={styles['geo-item']} />
                  <SkeletonRect className={styles['geo-item']} />
                  <SkeletonRect className={styles['geo-item']} />
                </div>
              }
              header={
                <div className={styles['header']}>
                  <SkeletonRect className={styles['title']} />
                  <SkeletonRect className={styles['subtitle']} />
                </div>
              }
              labels={
                <div className={styles['labels']}>
                  <SkeletonRect className={styles['labels-item']} />
                  <SkeletonRect className={styles['labels-item']} />
                </div>
              }
              price={<SkeletonRect className={styles['price']} />}
              publisher={
                <div className={styles['publisher-container']}>
                  <SkeletonRect className={styles['publisher']} />
                  <SkeletonRect className={styles['publication-date']} />
                </div>
              }
            />
          }
          gallery={
            <GalleryLayout
              slider={<SkeletonRect className={styles['gallery']} />}
              thumbnails={
                <div className={styles['thumbnails']}>
                  <SkeletonRect className={styles['thumbnail']} />
                  <SkeletonRect className={styles['thumbnail']} />
                  <SkeletonRect className={styles['thumbnail']} />
                </div>
              }
            />
          }
          isTop={isTop}
          publisher={
            <PublisherDesktopLayout
              controls={null}
              publisher={
                <div className={styles['publisher-desktop']}>
                  <SkeletonRect className={styles['publisher-avatar']} />

                  <div className={styles['publisher-content']}>
                    <SkeletonRect height={20} />
                    <SkeletonRect height={20} />
                    <SkeletonRect height={20} />
                  </div>

                  <div className={styles['publisher-actions']}>
                    <SkeletonRect height={28} />
                    <SkeletonRect height={28} />
                  </div>
                </div>
              }
              vas={null}
            />
          }
          onClick={() => {}}
        />
      </CardListItem>
    ),
    [isTop],
  );

  return (
    <CardList isResponsive isNarrow={isNarrow}>
      {Array.from({ length: of }).map((_, index) => renderThumbnail(index))}
    </CardList>
  );
}
